import { render } from "./scroller.vue?vue&type=template&id=145b7a7b"
import script from "./scroller.vue?vue&type=script&lang=js"
export * from "./scroller.vue?vue&type=script&lang=js"

import "./scroller.vue?vue&type=style&index=0&id=145b7a7b&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__